import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { JSZip } from 'jszip/dist/jszip';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ExamStreamDataComponent } from '../exam-stream-data/exam-stream-data.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-course-dialog-box',
  templateUrl: './course-dialog-box.component.html',
  styleUrls: ['./course-dialog-box.component.scss']
})
export class CourseDialogBoxComponent implements OnInit {
  courseForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  list;
  preFixValue
  courseList: any;
  CourseFormArray;
  fcCodeList: any;
  filteredListFcCode: any;
  APIService: string;
  coursePatternList: any;
  filteredCoursePatternList: any;
  courseMediumList: any;
  selectedIndex: number = 0;
  filteredCourseMediumList: any;
  courseScaleList: any;
  filteredCourseScaleList: any;
  courseEvaluationList: any;
  filteredCourseEvaluationList: any;
  courseRulesList: any;
  BranchDisabled = true;
  filteredCourseRulesList: any;
  courseGradeList: any;
  filteredCourseGradeList: any;
  courseGradeMarkList: any;
  isReadonly = false;
  isDeleteReadonly = false;
  filteredCourseGradeMarkList: any;
  dialogRef: MatDialogRef<any>;
  deleteButton = false;
  checked: boolean;
  CoSpSubBoolean = false;
  CoDebarBoolean = false;
  CoPassPCBoolean = false;
  CoRgPrfxBoolean = false;
  CoGPAmBoolean = false;
  CoGPtsBoolean = false;
  CoRelGrdBoolean = false;
  dynamicrecords: any[];
  showCbcs = false;
  userPermission: any;
  cbcs;
  cocbcs
  CourseCreate = true;
  CourseUpdate = true;
  CourseDelete = true;
  userTypee: string;
  branchView = true;
  uType: any;
  user: any;
  utp: any;
  courseLevelList: any;
  filteredcourseLevelList: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    public router: Router,
    private dialogRef2: MatDialogRef<CourseDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { this.APIService = environment.serviceUrl; }
  @ViewChild(ExamStreamDataComponent, { static: false }) private ExamStreamData: ExamStreamDataComponent;
  ngOnInit(): void {
    this.cbcs = this.umsService.secretdata['CBCS'];
    this.submitButton = true;
    this.editButton = false;
    this.deleteButton = false;
    this.list = true;
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');

    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Course' && element.PCreate == false) {
          this.CourseCreate = false;
        }
        if (element.PageName == 'Course' && element.PUpdate == false) {
          this.CourseUpdate = false;
        }
        if (element.PageName == 'Course' && element.PDelete == false) {
          this.CourseDelete = false;
        }
        if (element.PageName == 'Branch/Stream' && element.PView == false) {
          this.branchView = false;
        }
      });
    }

    this.loadsettingspage();
    this.courseForm = this.fb.group({
      CoCode: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-z0-9-&]*$")]),
      CoName: new FormControl('', [Validators.required, Validators.pattern('^[\\S]{1,}[\\S\\s]*|[\\s]*[\\S]{1,}[\\S\\s]*')]),
      CoFcCode: new FormControl('', [Validators.required]),
      CoNameOnDegree: new FormControl('', [Validators.required]),
      CoNameOnDegreeM: new FormControl('', [Validators.required]),
      CoRgPrfx: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoYears: new FormControl('', [Validators.required, Validators.pattern("^[0-9 .]*$")]),
      CoExams: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$")]),
      CoMaxYr: new FormControl('', 
        [Validators.pattern("^[0-9]*$")
          // , 
          // Validators.max(20)
        ]
      ),
      CoMaxSn: new FormControl('', [Validators.pattern("^[0-9]*$")]),
      CoMediums: new FormControl(''),
      CoRegDist: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoSpSub: new FormControl(''),
      // remove kle [Validators.pattern("^[a-zA-Z0-9]*$")]
      CoLedger: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoMarkList: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPattern: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoRule: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPassPC: new FormControl('', [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]{1,2})?))$'), Validators.max(100)]),
      CoProgCGPA: new FormControl('', [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$')]),
      CoCBCS: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPassCR: new FormControl('', [Validators.pattern("^[0-9.]*$"),]),
      CoEval: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoGPts: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoDebar: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoGPAm: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoRelGrd: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      fcCode: new FormControl(''),
      RollNoPrfx: new FormControl(''),
      CourseLevel: new FormControl(''),
      Internship: new FormControl(''),
      InternDur: new FormControl(''),
    });

    this.getCourseData();
    this.fetchMedium();
    this.fetchEvaluation();
    this.fetchFacultyCode();
    this.fetchPattern();
    this.fetchRules();
    this.fetchGradePoints();
    this.fetchScaleDown();
    this.fetchGradeMarks();
    this.fetchCourseLevel();
    this.courseForm.controls['CoCBCS'].setValue('N');
    this.courseForm.controls['CoMediums'].setValue(['E']);
    this.courseForm.controls['CoEval'].setValue('M');

    this.courseForm.controls['CoRule'].setValue('GEN');
    window.scroll(0, 0);
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
    } else {
      // alert(this.data.key)
    }
     this.courseForm.get('Internship')?.valueChanges.subscribe((value) => {
    const durationControl = this.courseForm.get('InternDur');

    if (value == 1) {
      // If Yes → make duration mandatory
      durationControl?.setValidators([Validators.required]);
    } else {
      // If No → clear value and remove validation
      durationControl?.clearValidators();
      durationControl?.setValue('');
    }

    durationControl?.updateValueAndValidity();
  });
  }


  ngAfterViewInit(): void {
    let e = '';
    let k = '';
    // this.loadsettingspage();
    this.prepopulatedatapage(e)
    this.editdata(e, k)
  }

  Reset() {
    this.courseForm = this.fb.group({
      CoCode: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-z0-9-&]*$")]),
      CoName: new FormControl('', [Validators.required, Validators.pattern('^[\\S]{1,}[\\S\\s]*|[\\s]*[\\S]{1,}[\\S\\s]*')]),
      CoFcCode: new FormControl('', [Validators.required]),
      CoNameOnDegree: new FormControl('', [Validators.required]),
      CoNameOnDegreeM: new FormControl('', [Validators.required]),
      CoRgPrfx: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoYears: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$")]),
      CoExams: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$")]),
       CoMaxYr: new FormControl('', 
        [Validators.pattern("^[0-9]*$")
          // , 
          // Validators.max(20)
        ]
      ),
      CoMaxSn: new FormControl('', [Validators.pattern("^[0-9]*$")]),
      CoMediums: new FormControl(''),
      CoRegDist: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoSpSub: new FormControl(''),
      // remove kle [Validators.pattern("^[a-zA-Z0-9]*$")]
      CoLedger: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoMarkList: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPattern: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoRule: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPassPC: new FormControl('', [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]{1,2})?))$'), Validators.max(100)]),
      CoProgCGPA: new FormControl('', [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$')]),
      CoCBCS: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPassCR: new FormControl('', [Validators.pattern("^[0-9.]*$")]),
      CoEval: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoGPts: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoDebar: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoGPAm: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoRelGrd: new FormControl('', [Validators.pattern("^[a-zA-Z0-9]*$")]),
      fcCode: new FormControl(''),
      RollNoPrfx: new FormControl(''),
      CourseLevel: new FormControl(''),
      Internship: new FormControl(''),
      InternDur: new FormControl(''),
    });
  }

  getCourseData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseList = [];
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }

  prepopulation(id) {
    console.log("llllllllll",id);
    
    let value = id.CoMediums.split(',');
    this.fetchFacultyCode();
    this.fetchPattern();
    // this.fetchMedium();
    // this.fetchEvaluation();
     this.fetchCourseLevel();
    this.fetchGradePoints();
    this.fetchScaleDown();
    this.fetchGradeMarks();
    this.isReadonly = true;
    this.isDeleteReadonly = false;
    this.BranchDisabled = false;
    let CoRelGrd = false;
    let CoDebar = false;
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    sessionStorage.setItem('CoCode', id.CoCode);
    sessionStorage.setItem('CoName', id.CoName);
    sessionStorage.setItem('CoNameOnDegree', id.CoNameOnDegree);
    if (id.CoRelGrd == 1) {
      CoRelGrd = true
    } else {
      CoRelGrd = false
    }
    if (id.CoDebar == 1) {
      CoDebar = true
    } else {
      CoDebar = false
    }
    if (this.cbcs == "") {
      this.showCbcs = false;
      this.cocbcs = '';
    }
    else {

      this.showCbcs = true;
      // this.courseForm.controls["CoCBCS"].setValue('No');
      this.cocbcs = 'N';
    }
let Internship;
     if (id.Internship == true) {
      Internship = 1
    } else {
      Internship = 0
    }
    this.courseForm = this.fb.group({

      CoCode: new FormControl(id.CoCode, [Validators.required, Validators.pattern("^[a-zA-z0-9-&]*$")]),
      CoName: new FormControl(id.CoName, [Validators.required, Validators.pattern('^[\\S]{1,}[\\S\\s]*|[\\s]*[\\S]{1,}[\\S\\s]*')]),
      CoFcCode: new FormControl(id.CoFcCode, [Validators.required]),
      CoNameOnDegree: new FormControl(id.CoNameOnDegree, [Validators.required]),
      CoNameOnDegreeM: new FormControl(id.CoNameOnDegreeM, [Validators.required]),
      CoRgPrfx: new FormControl(id.CoRgPrfx, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoYears: new FormControl(id.CoYears, [Validators.required, Validators.pattern("^[0-9]*$")]),
      CoExams: new FormControl(id.CoExams, [Validators.required, Validators.pattern("^[0-9]*$")]),
       CoMaxYr: new FormControl('', 
        [Validators.pattern("^[0-9]*$")
          // , 
          // Validators.max(20)
        ]
      ),
      CoMaxSn: new FormControl(id.CoMaxSn, [Validators.pattern("^[0-9]*$")]),
      CoMediums: new FormControl(value),
      CoRegDist: new FormControl(id.CoRegDist, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoSpSub: new FormControl(id.CoSpSub,),
      // [Validators.pattern("^[a-zA-Z0-9]*$")] KLE
      CoLedger: new FormControl(id.CoLedger, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoMarkList: new FormControl(id.CoMarkList, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPattern: new FormControl(id.CoPattern, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoRule: new FormControl(id.CoRule, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPassPC: new FormControl(id.CoPassPC, [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]{1,2})?))$'), Validators.max(100)]),
      CoProgCGPA: new FormControl(id.CoProgCGPA, [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$')]),
      CoCBCS: new FormControl(id.CoCBCS, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPassCR: new FormControl(id.CoPassCr, [Validators.pattern("^[0-9.]*$")]),
      CoEval: new FormControl(id.CoEval, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoGPts: new FormControl(id.CoGPts, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoDebar: new FormControl(CoDebar, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoGPAm: new FormControl(id.CoGPAm, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoRelGrd: new FormControl(CoRelGrd, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      RollNoPrfx: new FormControl(id.RollNoPrfx),
      CourseLevel: new FormControl(id.CourseLevel),
      Internship: new FormControl(Internship),
      InternDur: new FormControl(id.InternDur)
    });
  }

  submit() {
    if (this.courseForm.invalid) {
      this.BranchDisabled = true;
      this.courseForm.get('CoCode').markAsTouched();
      this.courseForm.get('CoName').markAsTouched();
      this.courseForm.get('CoNameOnDegree').markAsTouched();
      this.courseForm.get('CoNameOnDegreeM').markAsTouched();
      this.courseForm.get('CoFcCode').markAsTouched();
      this.courseForm.get('CoYears').markAsTouched();
      this.courseForm.get('CoExams').markAsTouched();
      this.courseForm.get('CoMaxYr').markAsTouched();
      this.courseForm.get('CoMediums').markAsTouched();
      this.courseForm.get('CoPattern').markAsTouched();
      this.courseForm.get('CoEval').markAsTouched();
      this.courseForm.get('CoPassCR').markAsTouched();
      this.courseForm.get('CoRule').markAsTouched();
      this.courseForm.get('CoProgCGPA').markAsTouched();
      this.courseForm.get('CourseLevel').markAsTouched();
      this.courseForm.get('Internship').markAsTouched();
      this.courseForm.get('InternDur').markAsTouched();
      this.courseForm.get('CoCBCS').markAsTouched();
      this.courseForm.get('CoSpSub').markAsTouched();
      // this.courseForm.get('CoRgPrfx').markAsTouched();
      this.courseForm.get('CoGPAm').markAsTouched();
      this.courseForm.get('CoPassPC').markAsTouched();
      this.courseForm.get('CoGPts').markAsTouched();
      this.courseForm.get('CoRelGrd').markAsTouched();
      this.courseForm.get('CoDebar').markAsTouched();
      return;
    } else {
      this.course();
    }
  }

  course() {
    this.spinner.show();
    this.submitpayload = this.courseForm.value;
    let payload = {};
    // if (this.submitpayload.CoCBCS == 'N') {
    //   payload["CoCode"] = this.submitpayload.CoCode;
    //   payload["CoFcCode"] = this.submitpayload.CoFcCode;
    //   payload["CoName"] = this.submitpayload.CoName;
    //   payload["CoCBCS"] = this.submitpayload.CoCBCS;
    // } else {
    //   payload = this.courseForm.value;
    // }
    // this.submitpayload['CoRgPrfx'] = this.preFixValue
    this.umsService.addCourse(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      this.BranchDisabled = false;
      if (res.status) {
        sessionStorage.setItem('CoCode', this.submitpayload.CoCode);
        sessionStorage.setItem('CoName', this.submitpayload.CoName);
        sessionStorage.setItem('CoNameOnDegree', this.submitpayload.CoNameOnDegree);
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.dialogRef2.close();
        });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close();
        });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  update() {
    if (this.courseForm.invalid) {
      this.courseForm.get('CoCode').markAsTouched();
      this.courseForm.get('CoName').markAsTouched();
      this.courseForm.get('CoNameOnDegree').markAsTouched();
      this.courseForm.get('CoNameOnDegreeM').markAsTouched();
      this.courseForm.get('CoFcCode').markAsTouched();
      this.courseForm.get('CoYears').markAsTouched();
      this.courseForm.get('CoExams').markAsTouched();
      this.courseForm.get('CoMaxYr').markAsTouched();
      this.courseForm.get('CoMediums').markAsTouched();
      this.courseForm.get('CoPattern').markAsTouched();
      this.courseForm.get('CoEval').markAsTouched();
      this.courseForm.get('CoPassCR').markAsTouched();
      this.courseForm.get('CoRule').markAsTouched();
      this.courseForm.get('CoProgCGPA').markAsTouched();
      this.courseForm.get('CoCBCS').markAsTouched();
      this.courseForm.get('CoSpSub').markAsTouched();
      // this.courseForm.get('CoRgPrfx').markAsTouched();
      this.courseForm.get('CoGPAm').markAsTouched();
      this.courseForm.get('CoPassPC').markAsTouched();
      this.courseForm.get('CoGPts').markAsTouched();
      this.courseForm.get('CoRelGrd').markAsTouched();
      this.courseForm.get('CoDebar').markAsTouched();
      return;
    } else {
      this.updateCourese();
    }
  }

  updateCourese() {
    this.spinner.show();
    this.submitpayload = this.courseForm.value;
    // this.submitpayload['CoRgPrfx'] = this.preFixValue
    this.umsService.updateCourse(this.submitpayload).subscribe(res => {
      sessionStorage.setItem('CoName', this.submitpayload.CoName);
      sessionStorage.setItem('CoNameOnDegree', this.submitpayload.CoNameOnDegree);
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  fetchFacultyCode() {
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.fcCodeList = res.data;
        this.filteredListFcCode = this.fcCodeList.slice();
      }
    })
  }

  facultySort(e) {
    const payload = {};
    payload['CoFcCode'] = e.FcCode;
    payload['LoginId'] = '0'
    this.umsService.getCourse(payload).subscribe(res => {
      this.courseList = res.data;
    }, (ERROR: HttpErrorResponse) => {
      this.courseList = [];
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }



  fetchPattern() {
    const payload = {};
    this.umsService.getCoursePattern().subscribe(res => {
      if (res.status) {
        this.coursePatternList = res.data;
        this.filteredCoursePatternList = this.coursePatternList.slice();
      }
    })
  }

  fetchMedium() {
    this.umsService.getCourseMedium().subscribe(res => {
      if (res.status) {
        this.courseMediumList = res.data;
        // this.medi = res.data.
        this.filteredCourseMediumList = this.courseMediumList.slice();
        // this.courseForm.controls['CoMediums'].setValue(['E']);

      }
    })
  }

  fetchScaleDown() {
    this.umsService.getScaleDown().subscribe(res => {
      if (res.status) {
        this.courseScaleList = res.data;
        this.filteredCourseScaleList = this.courseScaleList.slice();
      }
    })
  }

  fetchEvaluation() {
    this.umsService.getEvaluation().subscribe(res => {
      if (res.status) {
        this.courseEvaluationList = res.data;
        this.filteredCourseEvaluationList = this.courseEvaluationList.slice();
        // this.courseForm.controls['CoEval'].setValue('M');
      }
    })
  }
  fetchRules() {
    this.umsService.getRules().subscribe(res => {
      if (res.status) {
        this.courseRulesList = res.data;
        this.filteredCourseRulesList = this.courseRulesList.slice();
        // this.courseForm.controls['CoRule'].setValue('GEN');
      }
    })
  }
  fetchGradePoints() {
    this.umsService.getGradePoints().subscribe(res => {
      if (res.status) {
        this.courseGradeList = res.data;
        this.filteredCourseGradeList = this.courseGradeList.slice();
      }
    })
  }

  fetchGradeMarks() {
    this.umsService.getGpaMarks().subscribe(res => {
      if (res.status) {
        this.courseGradeMarkList = res.data;
        this.filteredCourseGradeMarkList = this.courseGradeMarkList.slice();
      }
    })
  }

  openDialog(id) {
    let data = {}
    data['message'] = id.message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-trash'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
    });
  }


  deletee(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }
  openConformationModalBox() {
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.deletedata(this.courseForm.value);
      }
    });
  }

  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        CoCode: id.CoCode,
        CoName: id.CoName,
        CoNameOnDegree: id.CoNameOnDegree,
        CoNameOnDegreeM: id.CoNameOnDegreeM,
        CoFcCode: id.CoFcCode,
        CoRgPrfx: id.CoRgPrfx,
        CoYears: id.CoYears,
        CoExams: id.CoExams,
        CoMaxYr: id.CoMaxYr,
        CoMaxSn: id.CoMaxSn,
        CoMediums: id.CoMediums,
        CoRegDist: id.CoRegDist,
        CoSpSub: id.CoSpSub,
        CoLedger: id.CoLedger,
        CoMarkList: id.CoMarkList,
        CoPattern: id.CoPattern,
        CoRule: id.CoRule,
        CoPassPC: id.CoPassPC,
        CoProgCGPA: id.CoProgCGPA,
        CoCBCS: id.CoCBCS,
        CoPassCR: id.CoPassCR,
        CoEval: id.CoEval,
        CoGPts: id.CoGPts,
        CoDebar: id.CoDebar,
        CoGPAm: id.CoGPAm,
        CoRelGrd: id.CoRelGrd,
        RollNoPrfx:id.RollNoPrfx,
       CourseLevel:id.CourseLevel,
       Internship:id.Internship,
       InternDur:id.InternDur,
      },
    };
    this.httpClient.delete(this.APIService + '/masters/course', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ngOnInit();
          this.dialogRef2.close();
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      });

  }

  prepopulationForDelete(id) {
    let value = id.CoMediums.split(',');
    this.fetchFacultyCode();
    this.fetchPattern();
    // this.fetchMedium();
    // this.fetchEvaluation();
    // this.fetchRules();
    this.fetchGradePoints();
    this.fetchScaleDown();
    this.fetchGradeMarks();
    this.isDeleteReadonly = true;
    this.editButton = false;
    this.submitButton = false;
    this.BranchDisabled = false;
    this.deleteButton = true;
    let CoRelGrd = false;
    let CoDebar = false;
    if (id.CoRelGrd == 1) {
      CoRelGrd = true
    } else {
      CoRelGrd = false
    }
    if (id.CoDebar == 1) {
      CoDebar = true
    } else {
      CoDebar = false
    }
    this.courseForm = this.fb.group({
      CoCode: new FormControl(id.CoCode, [Validators.required, Validators.pattern("^[a-zA-z0-9-&]*$")]),
      CoName: new FormControl(id.CoName, [Validators.required]),
      CoNameOnDegree: new FormControl(id.CoNameOnDegree, [Validators.required]),
      CoNameOnDegreeM: new FormControl(id.CoNameOnDegreeM, [Validators.required]),
      CoFcCode: new FormControl(id.CoFcCode, [Validators.required]),
      CoRgPrfx: new FormControl(id.CoRgPrfx, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoYears: new FormControl(id.CoYears, [Validators.required, Validators.pattern("^[0-9]*$")]),
      CoExams: new FormControl(id.CoExams, [Validators.required, Validators.pattern("^[0-9]*$")]),
       CoMaxYr: new FormControl('', 
        [Validators.pattern("^[0-9]*$")
          // , 
          // Validators.max(20)
        ]
      ),
      CoMaxSn: new FormControl(id.CoMaxSn, [Validators.pattern("^[0-9]*$")]),
      CoMediums: new FormControl(value),
      CoRegDist: new FormControl(id.CoRegDist, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoSpSub: new FormControl(id.CoSpSub,),
      // [Validators.pattern("^[a-zA-Z0-9]*$")] KLE
      CoLedger: new FormControl(id.CoLedger, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoMarkList: new FormControl(id.CoMarkList, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPattern: new FormControl(id.CoPattern, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoRule: new FormControl(id.CoRule, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPassPC: new FormControl(id.CoPassPC, [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]{1,2})?))$'), Validators.max(100)]),
      CoProgCGPA: new FormControl(id.CoProgCGPA, [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$')]),
      CoCBCS: new FormControl(id.CoCBCS, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoPassCR: new FormControl(id.CoPassCr, [Validators.pattern("^[0-9.]*$")]),
      CoEval: new FormControl(id.CoEval, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoGPts: new FormControl(id.CoGPts, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoDebar: new FormControl(CoDebar, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoGPAm: new FormControl(id.CoGPAm, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      CoRelGrd: new FormControl(CoRelGrd, [Validators.pattern("^[a-zA-Z0-9]*$")]),
      RollNoPrfx:new FormControl(id.RollNoPrfx),
      CourseLevel: new FormControl(id.CourseLevel),
      Internship: new FormControl(id.Internship),
      InternDur: new FormControl(id.InternDur)
    });
  }

  slideToggleChange(event: MatSlideToggleChange) {
    this.checked = event.source.checked;
  }


  onTabChanged(event: MatTabChangeEvent) {
    if (event.tab.textLabel == 'Branch/Stream') {
      let code = sessionStorage.getItem('CoCode');
      let name = sessionStorage.getItem('CoName');
      let nameondegree = sessionStorage.getItem('CoNameOnDegree');
      this.ExamStreamData.ngOnInit();
      //this.ExamStreamData.getCodeData(k);
    }

  }

  public next() {
    this.selectedIndex += 1;
    this.ExamStreamData.ngOnInit();

  }

  public prev() {
    this.selectedIndex -= 1;
  }

  checkmaxyears() {
    // if (this.courseForm.controls['CoMaxYr'].value < this.courseForm.controls['CoYears'].value) {
    //   this.courseForm.controls['CoMaxYr'].setValue('');
    //   let data = {}
    //   data['message'] = 'Course Max Year Must Be Same As Course Year Or Greater'
    //   data['title'] = 'Information'
    //   data['icon'] = 'fa fa-question'
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    // }
    const maxYr = Number(this.courseForm.controls['CoMaxYr'].value);
      const yrs   = Number(this.courseForm.controls['CoYears'].value);

      if (maxYr < yrs) {
        this.courseForm.controls['CoMaxYr'].setValue('');
        
        let data = {
          message: 'Course Max Year Must Be Same As Course Year Or Greater',
          title: 'Information',
          icon: 'fa fa-question'
        };

        this.dialogRef =
          this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
      }

  }

  checkmaxyears1() {
    // if (this.courseForm.controls['CoMaxYr'].value > 0) {
    //   if (this.courseForm.controls['CoYears'].value > this.courseForm.controls['CoMaxYr'].value) {
    //     this.courseForm.controls['CoMaxYr'].setValue('');
    //     let data = {}
    //     data['message'] = 'Course Max Year Must Be Same As Course Year Or Greater'
    //     data['title'] = 'Information'
    //     data['icon'] = 'fa fa-question'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   }
    // }
    const maxYr = Number(this.courseForm.controls['CoMaxYr'].value);
    const yrs   = Number(this.courseForm.controls['CoYears'].value);

    if (!isNaN(maxYr) && !isNaN(yrs) && maxYr > 0 && yrs > 0 && yrs > maxYr) {

      this.courseForm.controls['CoMaxYr'].setValue('');


      let data = {
        message: 'Course Max Year Must Be Same As Course Year Or Greater',
        title: 'Information',
        icon: 'fa fa-question'
      };

      this.dialogRef =
        this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
    }

  }

  loadsettingspage() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'Course';
    // payload['Inst'] = sessionStorage.getItem('Inst');
    this.dynamicrecords = [];
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      this.dynamicrecords = res.data;
      res.data.forEach((element) => {
        if (element.FormVisible) {
          this[element.FormControlName + 'Boolean'] = element.FormVisible;
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.courseForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            }
            else {
              this.courseForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          }

          else {
            this.courseForm.addControl(element.FormControlName, new FormControl(''));
            // this.requireddd = false;
          }
        } else {
          this[element.FormControlName + 'Boolean'] = element.FormVisible;
          // this.requireddd = false;
        }
      });
      this.mapdataaa(res.data);
    });
  }
  // enable() {
  //   this.BranchDisabled = false;
  // }

  mapdataaa(e) {
    this.CourseFormArray = e.reduce(function (r, a) {
      r[a.FormControlName] = r[a.FormControlName] || [];
      r[a.FormControlName].push(a);
      return r;
    }, Object.create(null));
  }


  prepopulatedatapage(e) {
    let payload1 = {};
    payload1['FormPage'] = 'Course';
    // this.courseForm.controls['StuId'].setValue(e.data[0]['StuId']);
    this.umsService.getStdSetting(payload1).subscribe((ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.courseForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
            }
            else {
              this.courseForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.courseForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.courseForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.mapdataaa(ress.data);
    });
  }



  rollNoPrefix(value) {
    const value1 = '00'
    const concatenatedArray = value1.concat(value);
    this.preFixValue = concatenatedArray.concat('2')
    // this.courseForm.controls['CoRgPrfx'].setValue('this.preFixValue');
  }

  fetchCourseLevel() {
    const payload = {};
    payload['CdType'] = 'COLVL';
    this.umsService.getCodeType(payload).subscribe(res => {
      if (res.status) {
        this.courseLevelList = res.data;
        this.filteredcourseLevelList = this.courseLevelList.slice();

      }
    })
  }
}